'use client'

import { CrossSellingProducts } from 'cross-selling/components/shared/CrossSelling/client/ClientCrossSelling/CrossSellingProducts'
import type { CrossSellingClientProps } from 'cross-selling/types'
import { HorizontalScroll } from 'fukku/HorizontalScroll'
import { ProductCardImagesSizesProvider } from 'product-card/context/ProductCardImagesSizesContext'

export const ClientCrossSelling = ({
	crossSellingItems,
	titleProps,
	linkProps,
	expanded,
	imageSortCriteria,
	productCardImagesSizes,
	hasSizeSheetButton = true,
	productsData,
	className,
	productCardClassName,
	location,
	productListId,
	hasFavoriteButton,
	'data-testid': dataTestId,
	showDiscount,
}: CrossSellingClientProps) => {
	return (
		<HorizontalScroll
			titleProps={titleProps}
			linkProps={linkProps}
			expanded={expanded}
			className={className}
			data-testid={dataTestId}
		>
			<ProductCardImagesSizesProvider
				initialImageSizes={{ regular: productCardImagesSizes }}
			>
				<CrossSellingProducts
					crossSellingItems={crossSellingItems}
					productsData={productsData}
					imageSortCriteria={imageSortCriteria}
					expanded={expanded}
					hasSizeSheetButton={hasSizeSheetButton}
					hasProductLabels={false}
					hasProductTags={false}
					hasColorPicker={false}
					productCardClassName={productCardClassName}
					location={location}
					productListId={productListId}
					hasFavoriteButton={hasFavoriteButton}
					showDiscount={showDiscount}
				/>
			</ProductCardImagesSizesProvider>
		</HorizontalScroll>
	)
}
